import { useEffect, useState } from "react";
import { adminApi, clientApi } from "@/lib/api";
import { CapabilityNotice } from "@/components/bse/BseUatForm";

export function useBseCapability(operation) {
  const [capability, setCapability] = useState(null);
  useEffect(() => {
    let active = true;
    clientApi.get("/bse/status", { showErrorToast: false }).then((response) => {
      if (active) setCapability(response.data.capabilities?.operations?.[operation] || null);
    }).catch(() => {
      if (active) setCapability({ key: operation, environment: "UNKNOWN", state: "STATUS_UNAVAILABLE",
        enabled: false, label: "BSE operation", reason: "BSE capability status could not be loaded. Submission is disabled." });
    });
    return () => { active = false; };
  }, [operation]);
  return capability;
}

export function BseCapabilityStatus({ operation, title }) {
  const capability = useBseCapability(operation);
  return <CapabilityNotice capability={capability} title={title} />;
}

export function useAdminBseCapability(operation) {
  const [capability, setCapability] = useState(null);
  useEffect(() => {
    let active = true;
    adminApi.get("/admin/bse2/capabilities", { showErrorToast: false }).then((response) => {
      if (active) setCapability(response.data.operations?.[operation] || null);
    }).catch(() => {
      if (active) setCapability({ key: operation, environment: "UNKNOWN", state: "STATUS_UNAVAILABLE",
        enabled: false, label: "BSE operation", reason: "BSE capability status could not be loaded. Submission is disabled." });
    });
    return () => { active = false; };
  }, [operation]);
  return capability;
}
